import Splide from '@splidejs/splide';

(function () {
  const $carousels = document.querySelectorAll('.tr-infinite-slider .tr-infinite-slider-container');

  if ($carousels.length) {
    $carousels.forEach($carousel => {
      const options = {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        arrows: true,
        pagination: true,
        mediaQuery: 'min',
        // gap: '20px',
        breakpoints: {
          0: {
            // Default settings for 576px and up
            perPage: 1,
            center: true,
            padding: {
              left: '10vw',
              right: '10vw'
            }
          },

          768: {
            // Settings for 768px and up
            perPage: $carousel.classList.contains('large_desktop') ? 2 : 4,
            center: $carousel.classList.contains('large_desktop') ? true : false,
            padding: {
              left: $carousel.classList.contains('large_desktop') ? '18vw' : undefined,
              right: $carousel.classList.contains('large_desktop') ? '18vw' : undefined,
            }
          }
        }
      };

      new Splide($carousel, options).mount();
    });
  }
})();